<template>
  <NestedMenu title="Choose how you want to boss your fries"
              platform="kiosk">
    <ProductMenuInlineLayout>
      <ProductCard v-for="product in products"
                   :key="product.title"
                   :product="product"
                   @click="product.onClick" />
    </ProductMenuInlineLayout>
  </NestedMenu>
</template>

<script>
import Component from 'vue-class-component';
import Vue from 'vue';
import NestedMenu from '@/components/NestedMenu';
import ProductMenuInlineLayout from '@/apps/shared/components/ProductMenuInlineLayout';
import FiresMenuMixin from '@/apps/menu/mixins/fries-menu-mixin';
import ProductCard from '@/apps/shared/components/ProductCard';

/**
 * Menu for boss your fries page
 */
@Component({
  components: {
    NestedMenu,
    ProductCard,
    ProductMenuInlineLayout,
  },
  mixins: [
    FiresMenuMixin,
  ],
})
export default class KioskFriesMenu extends Vue {}
</script>



// WEBPACK FOOTER //
// src/apps/kiosk/components/KioskFriesMenu.vue